import { CookiePolicy } from "@policystack/react/policy";
import { createFileRoute } from "@tanstack/react-router";

import { PolicyPageLayout, policyComponents } from "#/components/PolicyPageLayout";
import { Separator } from "#/components/ui/separator";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

import {
  CookieManagePreferencesSection,
  CookiePaymentPagesSection,
  PolicyUpdatesSection,
} from "./-policy.supplements";

export const Route = createFileRoute("/cookie-policy")({
  head: () => documentHead(DOCUMENT_TITLES.cookiePolicy),
  component: CookiePolicyPage,
});

function CookiePolicyPage() {
  return (
    <PolicyPageLayout
      eyebrow="Legal"
      title="Cookie policy"
      description="How Daily Wars uses cookies and similar technologies, and how you can manage your choices."
    >
      <div className="flex flex-col gap-10">
        <CookiePolicy components={policyComponents} />
        <Separator />
        <CookiePaymentPagesSection />
        <PolicyUpdatesSection />
        <CookieManagePreferencesSection />
      </div>
    </PolicyPageLayout>
  );
}
